// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2Fixq","title":"Info_title__3zHFv","links":"Info_links__1ECmJ","link":"Info_link__zFDcl","logo":"Info_logo__MUBxe"};